import BackButton from "./back-button";


const Buttons = {
    Back : BackButton
};

export default Buttons;
